import { HttpErrorResponse } from '@angular/common/http';

// m:ss, for the waits of the sign-in lock and of the code.
export function clock(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}

// The wait a 429 asks for, in seconds; a minute when it names none.
export function retryAfterSeconds(err: HttpErrorResponse): number {
  return Math.max(1, Number(err?.error?.RetryAfter) || 60);
}

// The 429 of the sign-in lock next to a field: the words of the login page.
export function tooManyAttempts(err: HttpErrorResponse): { key: string, params: { time: string } } {
  return { key: 'LOGIN.TOO_MANY_ATTEMPTS', params: { time: clock(retryAfterSeconds(err)) } };
}

// The six digits of a code, from a paste with spaces or a line break.
export function codeDigits(value: string | null | undefined): string {
  return String(value ?? '').replace(/\D/g, '').slice(0, 6);
}
